import React from 'react';
import { BaseComponentProps } from '@/pages/benchmark/types/commom';
import classNames from 'classnames';
import './index.scss';
import RenderConfigText from '@home/components/RenderConfigText';

export interface IHomeFooterProps extends BaseComponentProps {
  textEn: string;
  textCn: string;
  urls: string[];
}

export default function OpinionsFooter(props: IHomeFooterProps) {
  const {
    style,
    className,
    textEn = 'If you have any questions or suggestions regarding this page, please contact kamilw@funcom.com.',
    textCn = '如有问题，请联系 kamilw@funcom.com.',
  } = props || {};

  return (
    <div
      className={classNames('dbh-studio-opinions-foolter-container', className)}
      style={style}
    >
      <RenderConfigText contentEn={textEn} contentCn={textCn} />
    </div>
  );
}
